// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":export {\n  menuText: #333;\n  menuActiveText: #2fa9af;\n  subMenuActiveText: #2fa9af;\n  menuBg: #FFFFFF;\n  menuHover: #e7f4f5;\n  subMenuBg: #FFFFFF;\n  subMenuHover: #e7f4f5;\n  sideBarWidth: 270px;\n  primary: #2fa9af; }\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
